import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { SeasonTicket } from 'src/app/classes';
import { WidgetsmanagerService } from 'src/app/services/widgetsmanager.service';
import { WsmanagerService } from 'src/app/services/wsmanager.service';

@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.scss'],
})
export class SubscriptionsComponent implements OnInit {

  @Input('subscription')
  public subscription: SeasonTicket;

  @Input('closeEvent')
  public closeEvent: EventEmitter<any>;

  @Output('subscriptionDeleted')
  public subscriptionDeleted: EventEmitter<SeasonTicket>;

  public loading = false; 

  constructor(
    private alertController: AlertController,
    private translate: TranslateService,
    private wsManager: WsmanagerService,
    private widgetManager: WidgetsmanagerService
  ) { }

  ngOnInit() {}

  get remainingMinutes(): number {
    return Math.floor(Math.max(0, this.subscription.remainingSeconds || 0) / 60);
  }

  get totalMinutes(): number {
    const tt = this.subscription.ticketType;
    return Math.floor(((tt && tt.seconds) || 0) / 60);
  }

  get hasUnlimitedMinutes(): boolean {
    const s = Number(this.subscription.remainingSeconds);
    const tt = this.subscription.ticketType;
    const ts = tt ? Number(tt.seconds) : null;
    return s === -1 || ts === -1 || ts == null;
  }

  get hasUnlimitedUnlocks(): boolean {
    const ru = Number(this.subscription.remainingUnlocks);
    const tt = this.subscription.ticketType;
    const tu = tt ? Number(tt.unlocks) : null;
    return ru === -1 || tu === -1 || !!this.subscription.freeUnlocks || !!(tt && tt.freeUnlocks);
  }

  get hasUnlimitedKms(): boolean {
    const rk = Number(this.subscription.remainingKms);
    const tt = this.subscription.ticketType;
    const tk = tt ? Number(tt.included_kms) : null;
    return rk === -1 || tk === -1;
  }

  async delete(){

    const alert = await this.alertController.create({
      header: this.translate.instant('Are you sure to proceed?'),
      // message: 'Message <strong>text</strong>!!!',
      buttons: [
        {
          text: this.translate.instant('Dismiss'),
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
          }
        }, {
          text: 'Ok',
          handler: () => {
            this.loading = true;
            this.wsManager.deleteSubscription(this.subscription.id).subscribe(res => {
              this.widgetManager.showToastMessage('success', 'Subscription deleted succesfully');
              this.loading = false;
              this.subscriptionDeleted.emit(this.subscription);
              this.close();
            }, err => {
              console.log(err);
              this.widgetManager.showToastMessage('danger', 'Error while removing subscription');
            });
          }
        }
      ]
    });

    await alert.present();
  }

  close(){
    if (this.closeEvent) {
      this.closeEvent.emit();
    }
  }
}
